module.exports = __webpack_public_path__ + "static/media/pdf.218664a8.png";